module.exports = __webpack_public_path__ + "img/failed.a3e9dc03.svg";